<template>
  <div>
    <div class="filter-wrapper px-3 bg-white">
      <b-input-group prepend=" ">
        <b-input
          placeholder="Search Reward"
          v-model="searchKey"
          @keyup.native="searchRewards"
        ></b-input>
      </b-input-group>
    </div>
    <b-container class="bg-light py-2 mt-3">
      <b-row class="mt-1">
        <b-col v-if="rewardsList.length">
          <b-checkbox-group
            stacked
            v-model="computedSelectedRewards"
            :options="rewardsList"
            class="secondary-label search-body"
            text-field="name"
            value-field="uuid"
            @scroll.native="loadRewards"
            @input="setSelectedRewards"
          >
          </b-checkbox-group>
        </b-col>
        <b-col
          v-if="!loading && !rewardsList.length"
          class="text-center secondary-label"
        >
          No rewards found
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col class="text-center secondary-label"> Loading... </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="py-3 bg-white">
        <b-col>
          <b-button
            variant="link"
            class="text-muted secondary-label"
            @click="
              $emit('checked', {
                reference,
                selectedRewards: (selectedRewards = []),
              })
            "
          >
            Clear Selected
          </b-button>
        </b-col>
        <b-col cols="4">
          <b-btn
            variant="primary"
            class="btn-pill btn-block secondary-label"
            @click="
              $emit('checked', {
                reference,
                selectedRewards,
              })
            "
          >
            Apply
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "RewardsCheckbox",
    props: ["reference"],
    data() {
      return {
        rewardsList: [],
        selectedRewards: [],
        searchKey: "",
        page: 1,
        subTierRewards: {}
      };
    },
    computed: {
        ...mapState("rewards", ["loading", "rewards"]),
        ...mapFields("programMembershipTiers", ["tier"]),
        subTierIndex: {
          get() {
            return this.reference.replace(/\D/g, '');
          },
          set(subTierIndex) {
            return subTierIndex;
          }
        },
        computedSelectedRewards: {
          get() {
            const rewards = this.tier && !this.subTierIndex
              ? this.tier.rewards_uuids
              : this.tier && this.subTierIndex && this.tier.sub_tiers.length > 0
                ? this.tier.sub_tiers[this.subTierIndex].rewards_uuids
                : this.selectedRewards;
            
            this.selectedRewards = rewards;

            return rewards;
          },
          set(rewards) {
            return rewards;
          }
        }
    },
    methods: {
        ...mapActions("rewards", ["search", "getRewards"]),
        fetchRewards() {
            if (this.searchKey) {
                this.search({
                    apiFields: {
                        category: 1,
                        text: this.searchKey
                    },
                    page: this.page
                }).then(() => {
                    if (this.rewards)
                        this.rewardsList = [
                            ...this.rewardsList,
                            ...this.rewards
                        ];
                });
            } else {
                this.getRewards(this.page).then(() => {
                    if (this.rewards)
                        this.rewardsList = [
                            ...this.rewardsList,
                            ...this.rewards
                        ];
                });
            }
        },
        loadRewards(e) {
            if (
                e.target.offsetHeight + e.target.scrollTop >=
                e.target.scrollHeight - 1
            ) {
                if (this.page > 1 && !this.rewards) return;

                this.page++;
                this.fetchRewards();
            }
        },
        searchRewards() {
            this.page = 1;
            this.rewardsList = [];
            this.fetchRewards();
        },
        setSelectedRewards(rewards) {
          if (this.tier && !this.subTierIndex) this.tier.rewards_uuids = rewards;
          else if (this.tier && this.subTierIndex && this.tier.sub_tiers.length > 0) this.tier.sub_tiers[this.subTierIndex].rewards_uuids = rewards;
          else if (!this.tier) this.selectedRewards = rewards;
        }
    },
    created() {
      this.getRewards().then(() => {
        this.rewardsList = this.rewards;
      });
    },
    mounted() {
      this.$root.$on('clearSelectedRewards', () => {
        this.selectedRewards = [];
      });

      this.selectedRewards = [];
    },
    beforeDestroy() {
      this.$root.$off('clearSelectedRewards');
    }
};
</script>

<style>
</style>
